import React from 'react';
import { Box } from '@common-fe/common-fe';

import { ReactivationPlan } from '@/modules/employer/components/EmployerReactivation/types';

import { BulkPlanReactivationItem } from './BulkPlanReactivationItem/BulkPlanReactivationItem';

interface Props {
  plans: ReactivationPlan[];
}

const testId = 'BulkPlanReactivationList';

export const BulkPlanReactivationList: React.FC<Props> = ({ plans }) => {
  if (plans.length === 0) return null;

  return (
    <Box
      pad="spacing24"
      border={{ color: 'border1' }}
      round="container1Round"
      background={{ color: 'canvas' }}
    >
      {plans.map((plan, index) => (
        <React.Fragment key={plan.id}>
          {index > 0 && (
            <Box
              width="100%"
              height="1px"
              background={{ color: 'border1' }}
              margin={{ vertical: 'spacing16'}}
            />
          )}
          <BulkPlanReactivationItem
            testId={`${testId}_plan_${plan.id}`}
            plan={plan}
          />
        </React.Fragment>
      ))}
    </Box>
  );
};
